import React, { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Typography, CircularProgress } from '@mui/material';
import { makeItemsAccountData } from '../../utils/balance-accounts';
import ItemAccountsTable from '../../components/bills-accounts-statics/ItemAccountsTable';

const ItemAccountsContainer = ({ selectedYear, selectedPrjTyp, tableRef }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const onLoadData = () => {
    setLoading(true);
    const loadedData = makeItemsAccountData();
    setData(loadedData);
    setLoading(false);
  };

  useEffect(() => {
    onLoadData();
  }, [selectedYear, selectedPrjTyp]);

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      {loading ? (
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      ) : Array.isArray(data) && data.length === 0 ? (
        <Box>
          <Typography variant="subtitle2">데이터가 없습니다.</Typography>
        </Box>
      ) : (
        <ItemAccountsTable data={data} loading={loading} tableRef={tableRef} />
      )}
    </Box>
  );
};

export default ItemAccountsContainer;
